var module = angular.module('octopusApp.tasks');

module.controller('TaskRawController', function ($scope, $stateParams, octopusRepository, busy) {
  var isLoading = $scope.isLoading = busy.create();
  var id = $stateParams["taskId"];
  $scope.task = null;

  $scope.refresh = function() {
    isLoading.promise(octopusRepository.Tasks.get(id).then(function (task) {
      isLoading.promise(octopusRepository.Tasks.getRaw(task).then(function (raw) {
        $scope.task = task;
        $scope.rawLog = raw;
        $scope.rawDownloadLink = octopusRepository.resolve(task.Links["Raw"]);
      }));
    }));
  };

  $scope.refresh();
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/tasks/controllers/task_raw_controller.js
// module id = 5166511013983872
// module chunks = 1